import { extend } from '@/lib/utils/extend';
import Dialog from "vant/es/dialog";
import "vant/es/dialog/style/index.js";
var AbpMessage = /** @class */ (function () {
    function AbpMessage() {
    }
    AbpMessage.success = function (message, title, options) {
        options = options || {};
        options.message = message;
        options.title = title;
        return Dialog.alert(options);
    };
    AbpMessage.info = function (message, title, options) {
        options = options || {};
        options.message = message;
        options.title = title;
        return Dialog.alert(options);
    };
    AbpMessage.warn = function (message, title, options) {
        options = options || {};
        options.message = message;
        options.title = title;
        return Dialog.alert(options);
    };
    AbpMessage.error = function (message, title, options) {
        options = options || {};
        options.message = message;
        options.title = title;
        return Dialog.alert(options);
    };
    AbpMessage.confirm = function (message, title, options) {
        var thisOptions = {
            message: '',
            title: ''
        };
        var callback = function (result) { };
        if (typeof message === 'object') {
            thisOptions = message;
        }
        else {
            thisOptions.message = message;
        }
        if (typeof title === 'function') {
            callback = title;
        }
        else if (typeof title === 'object') {
            thisOptions = title;
        }
        else {
            thisOptions.title = title;
        }
        if (typeof options === 'function') {
            callback = options;
        }
        else if (typeof options === 'object') {
            thisOptions = options;
        }
        var result = Dialog.confirm(thisOptions);
        result.then(function () {
            callback(true);
        }).catch(function () {
            callback(false);
        });
        return result;
    };
    return AbpMessage;
}());
var abpMessage = {
    message: AbpMessage
};
window.abp = extend(true, window.abp, abpMessage);
